export default __webpack_public_path__ + "static/media/Coffee Gear 2.31a99ba3.jpg";